import { defineMessages } from "../core"

export const meetings = defineMessages({
  en: {
    "meetings.weekday.mon": "Mo",
    "meetings.weekday.tue": "Tu",
    "meetings.weekday.wed": "We",
    "meetings.weekday.thu": "Th",
    "meetings.weekday.fri": "Fr",
    "meetings.weekday.sat": "Sa",
    "meetings.weekday.sun": "Su",
    "meetings.previousMonth": "Previous month",
    "meetings.nextMonth": "Next month",
    "meetings.loadFailed": "Meetings could not be loaded.",
    "meetings.loading": "Loading meetings…",
    "meetings.none": "No meetings on this day.",
    "meetings.allDay": "all day",
    "meetings.toggleLabel": "Select meetings",
    "meetings.toggleTitle": "Prepare or follow up on meetings",
    "meetings.prepare": "Prepare",
    "meetings.followUp": "Follow up",
    "meetings.messagePrep": "Preparation",
    "meetings.messageRecap": "Follow-up",
    "meetings.messageCustom": "Custom instruction",
    "meetings.optionsFor": "Options for {subject}",
    "meetings.optionsTitle": "Choose a mode or enter a custom instruction",
    "meetings.optionsHeading": "Options for: {subject}",
    "meetings.defaultMode": "Default mode",
    "meetings.instructionPlaceholder": "Optional: a custom instruction replaces the default (e.g. Only summarize the open risks)",
    "meetings.instructionLabel": "Custom instruction",
    "meetings.cancel": "Cancel",
    "meetings.send": "Send",
    "meetings.range.pickStart": "Pick a start date",
    "meetings.range.to": "{start} to {end}",
    "meetings.range.selectLabel": "Select date range",
    "meetings.range.select": "Choose date range",
    "meetings.range.minimize": "Minimize date range",
    "meetings.range.reset": "Reset",
    "meetings.range.confirm": "Confirm",
  },
  de: {
    "meetings.weekday.mon": "Mo",
    "meetings.weekday.tue": "Di",
    "meetings.weekday.wed": "Mi",
    "meetings.weekday.thu": "Do",
    "meetings.weekday.fri": "Fr",
    "meetings.weekday.sat": "Sa",
    "meetings.weekday.sun": "So",
    "meetings.previousMonth": "Vorheriger Monat",
    "meetings.nextMonth": "Nächster Monat",
    "meetings.loadFailed": "Termine konnten nicht geladen werden.",
    "meetings.loading": "Termine werden geladen…",
    "meetings.none": "Keine Termine an diesem Tag.",
    "meetings.allDay": "ganztägig",
    "meetings.toggleLabel": "Meetings auswählen",
    "meetings.toggleTitle": "Meetings vorbereiten oder nachbereiten",
    "meetings.prepare": "Vorbereiten",
    "meetings.followUp": "Nachbereiten",
    "meetings.messagePrep": "Vorbereitung",
    "meetings.messageRecap": "Nachbereitung",
    "meetings.messageCustom": "Eigene Anweisung",
    "meetings.optionsFor": "Optionen für {subject}",
    "meetings.optionsTitle": "Modus wählen oder eigene Anweisung angeben",
    "meetings.optionsHeading": "Optionen für: {subject}",
    "meetings.defaultMode": "Standardmodus",
    "meetings.instructionPlaceholder": "Optional: eigene Anweisung ersetzt den Standard (z. B. Fasse nur die offenen Risiken zusammen)",
    "meetings.instructionLabel": "Eigene Anweisung",
    "meetings.cancel": "Abbrechen",
    "meetings.send": "Senden",
    "meetings.range.pickStart": "Startdatum wählen",
    "meetings.range.to": "{start} bis {end}",
    "meetings.range.selectLabel": "Zeitraum auswählen",
    "meetings.range.select": "Zeitraum wählen",
    "meetings.range.minimize": "Zeitraum minimieren",
    "meetings.range.reset": "Zurücksetzen",
    "meetings.range.confirm": "Bestätigen",
  },
})
